<template>
    <div>
        <b-row role="alert">
            <b-col>
                <div class="sr-only" v-if="isLoading">Loading, please wait...</div>
            </b-col>
        </b-row>
        <b-table hover small responsive show-empty
                 class="sr-caption"
                 aria-live="polite"
                 :id="slug"
                 :fields="fields"
                 :items="items"
                 primary-key="id"
                 :busy="isLoading"
                 sort-by="updateDate"
                 sort-direction="desc"
                 caption="Order table.  To sort the data in this table by a specific column,
                            go to the appropriate column header cell and use enter to sort the data ascending.
                            Use enter again to sort descending.">
            <template v-slot:cell(actions)="row">
                    <b-button v-if="row.item.status?.code === 'DRAFT'" size="sm" @click="viewCart(row.item)"
                              variant="primary"
                              class="mr-1">View Cart</b-button>
                    <b-button v-if="row.item.status?.code === 'PAY'" size="sm" @click="viewReceipt(row.item)"
                              variant="primary"
                              class="mr-1">Pay</b-button>
                    <b-button v-if="row.item.status?.code !== 'DRAFT'" size="sm" @click="viewReceipt(row.item)"
                              variant="primary"
                              class="mr-1">View Receipt</b-button>
                    <b-button v-if="row.item.status?.code === 'DRAFT' || row.item.status?.code === 'PAY'" size="sm"
                              @click="showDeleteModal(row.item)"
                              variant="danger"
                              class="mr-1">Cancel Order</b-button>
            </template>
            <template v-slot:cell(draftDate)="row">
              {{formatDateTime(row.item.draftDate)}}
            </template>
            <template v-slot:cell(orderDate)="row">
                {{formatDateTime(row.item.orderDate)}}
            </template>
            <template v-slot:cell(closedDate)="row">
                {{formatDateTime(row.item.closedDate)}}
            </template>
            <template v-slot:cell(updateDate)="row">
                {{formatDateTime(row.item.updateDate)}}
            </template>
            <template v-slot:empty="scope">
                <p>No orders found.</p>
            </template>
            <div slot="table-busy" class="center-text text-danger my-2">
                <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"
                           label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
                <strong>Loading, Please Wait...</strong>
            </div>
        </b-table>
      <b-modal size="xl" :id="'delete-modal' + modalId" hide-header hide-footer>
        <h2>Are you sure you want to cancel the order?</h2>
        <b-button variant="primary" @click="deleteOrder(selected)">Confirm</b-button>
        <b-button @click="hideDeleteModal" variant="secondary">Close</b-button>
      </b-modal>
    </div>
</template>
<style>
    .btn-primary-outline {
        background-color: transparent;
        border-color: transparent;
        box-shadow: none;
    }
    .btn-primary-outline:hover {
        background-color: transparent;
        border-color: transparent;
        box-shadow: none;
    }
</style>
<script>
    import moment from 'moment';
    import LocalStorageService from "@/common/LocalStorageService";
    import axios from "axios";
    import {toastService} from "@/mixins/toastService";

    const localStorageService = LocalStorageService.getService();

    export default {
        name: "OrdersTable",

        props:{
            items: Array,
            slug: [String],
            isLoading: Boolean,
            status: [String],
            modalId: [String],
        },
        data: () => {
          return {
            fields: [
              {key: 'orderNumber', label: 'Order Number'},
              {key: 'status.description', label: 'Status', sortable: true},
              {key: 'draftDate', label: 'Created Date', sortable: true},
              {key: 'orderDate', label: 'Order Date', sortable: true},
              {key: 'closedDate', label: 'Closed Date', sortable: true},
              {key: 'updateDate', label: 'Last Updated Date', sortable: true},
              {key: 'actions', label: 'Actions', sortable: false}
            ],
            selected: null,
          }
        },
        methods:{
            viewCart(item){
                localStorageService.setIsDraft(true)
                localStorageService.setOrderNumber(item.id)
                this.$emit('order-emit')
                this.$router.push({path: "cart"})
            },
            viewReceipt(item) {
              this.$router.push("/receipt/"+item.orderNumber)
            },
            pay(item) {
              axios.post(`${process.env.VUE_APP_API_BASE_URL}/payment/pay`, {id: item.id})
                  .then(response=> {
                    this.sendToUSBank(response.data)
                    localStorageService.clearCartItems()
                    localStorageService.clearOrderNumber()
                    localStorageService.clearOrderType()
                    localStorageService.clearIsDraft()
                  })
                  .catch(err => {
                    toastService.showRootToast("Error", "Unable to contact US Bank" , "danger", this.$root)
                  })
            },
          sendToUSBank(formData) {
            var usbForm = document.createElement('form')
            usbForm.method = 'post'
            usbForm.action = process.env.VUE_APP_USBANK_ENDPOINT
            for (var k in formData) {
              var input = document.createElement('input')
              input.setAttribute('name', k)
              input.setAttribute('value', formData[k])
              usbForm.appendChild(input) ;
            }
            document.body.appendChild(usbForm)
            usbForm.submit()
            document.body.removeChild(usbForm) ;
          },
            showDeleteModal(current){
              this.selected = current
              this.$bvModal.show('delete-modal' + this.modalId)
            },
            hideDeleteModal(){
              this.$bvModal.hide('delete-modal' + this.modalId)
              this.selected = {}
            },
            deleteOrder(item) {
              axios.delete(`${process.env.VUE_APP_API_BASE_URL}/order/delete/${item.id}`)
                  .then(response=>{
                    this.$emit('delete-order', item.status?.code)
                    this.hideDeleteModal()
                    this.selected = null
                  })
            },
            formatDate(unformattedDate){
                let formattedDate = moment(unformattedDate);
                if(!unformattedDate || !formattedDate.isValid()) return '';
                return formattedDate.format("MM/DD/YYYY")
            },
            formatDateTime(unformattedDate){
                let formattedDate = moment(unformattedDate);
                if(!unformattedDate || !formattedDate.isValid()) return '';
                return formattedDate.format("MM/DD/YYYY hh:mmA")
            },
        },
        mounted() {
        }
    }
</script>

<style scoped>

</style>